<div>
    <header class="mibi-header mat-h2">
        Zusätzlich gewünschte Untersuchungen
    </header>
    <div *ngIf="(warnings$ | async) as warnings">
        <mibi-dialog-warnings-view *ngIf="warnings.length > 0" class="mibi-warnings" [warnings]="warnings"></mibi-dialog-warnings-view>
    </div>
    <mat-horizontal-stepper
        [linear]="isLinear"
        #stepper
        class="mibi-analysis-stepper"
        color="accent"
    >
        <mat-step
            label="{{ nrl.abbreviation }}"
            *ngFor="
                let nrl of stepperViewModel$ | async;
                let first = first;
                let last = last
            "
        >
            <p>
                Das {{ nrl.abbreviation }} führt standardmäßig folgende Methoden
                durch: {{ nrl.standardProcedures.join("; ") }}
            </p>
            <p>
                Sollten Sie darüber hinaus weitere Wünsche zur Probenanalyse
                haben bzw. Zusatzinformationen zu Ihren Proben mitteilen wollen,
                klicken Sie bitte die entsprechende Option an.
            </p>
            <form [formGroup]="analysisForm[nrl.abbreviation]">
                <div class="mibi-optional-selection">
                    <mat-checkbox
                        *ngFor="let op of nrl.optionalProcedures; let j = index"
                        formControlName="{{ op.controlName }}"
                        >{{ op.value }}</mat-checkbox
                    >
                    <mat-checkbox
                        [(ngModel)]="showOther[nrl.abbreviation]"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="onChangeShowOther(nrl.abbreviation)"
                        >Sonstiges (nach Absprache)</mat-checkbox
                    >
                    <mibi-form-field *ngIf="showOther[nrl.abbreviation]">
                        <mat-form-field appearance="outline" class="mibi-other-input">
                            <textarea
                                #otherInput
                                matInput
                                type="text"
                                rows="1"
                                placeholder="Kommentar für das NRL"
                                formControlName="other"
                                maxlength="{{ maxCharacters }}"
                            ></textarea>
                            <mat-hint
                                align="start"
                                [class.mibi-other-hint--max-chars-reached]="(otherInput.value?.length || 0) >= maxCharacters"
                            >
                                {{otherInput.value?.length || 0}}/{{ maxCharacters }}
                            </mat-hint>
                        </mat-form-field>
                    </mibi-form-field>
                    <mat-checkbox
                        [(ngModel)]="showCompareHuman[nrl.abbreviation]"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="onChangeCompareHuman(nrl.abbreviation)"
                        >Vergleiche mit humanen Isolaten</mat-checkbox
                    >
                    <mibi-form-field *ngIf="showCompareHuman[nrl.abbreviation]">
                        <mat-form-field appearance="outline">
                            <textarea
                                #compareHumanInput
                                matInput
                                type="text"
                                rows="1"
                                placeholder="Kommentar für das NRL"
                                formControlName="compareHuman"
                                maxlength="{{ maxCharacters }}"
                            ></textarea>
                            <mat-hint
                                align="start"
                                [class.mibi-comparehuman-hint--max-chars-reached]="(compareHumanInput.value?.length || 0) >= maxCharacters"
                            >
                                {{compareHumanInput.value?.length || 0}}/{{ maxCharacters }}
                            </mat-hint>
                        </mat-form-field>
                    </mibi-form-field>
                    <div class="mibi-urgency-selection">
                        <label>Dringlichkeit:</label>
                        <mat-radio-group
                            formControlName="urgency"
                            aria-label="Dringlichkeit"
                            class="mibi-urgency-selection__button-group"
                        >
                            <mat-radio-button
                                value="NORMAL"
                                class="mibi-urgency-selection__button"
                                color="accent"
                                >normal</mat-radio-button
                            >
                            <mat-radio-button
                                color="accent"
                                value="EILT"
                                class="mibi-urgency-selection__button"
                                >eilt</mat-radio-button
                            >
                        </mat-radio-group>
                    </div>
                </div>
            </form>
            <div class="mibi-button-group">
                <button
                    class="mibi-button mibi-button--first"
                    mat-stroked-button
                    color="accent"
                    (click)="onCancel()"
                >
                    Zurück zu den Daten
                </button>
                <div class="mibi-stepper-button-group">
                    <button
                        class="mibi-stepper-button"
                        mat-button
                        color="accent"
                        matStepperPrevious
                        *ngIf="!first"
                    >
                        <mat-icon class="mibi-stepper-button-icon">navigate_before</mat-icon>
                        Vorheriges BfR-Labor
                    </button>
                    <button
                        class="mibi-stepper-button"
                        mat-button
                        color="accent"
                        matStepperNext
                        *ngIf="!last"
                    >
                        Nächstes BfR-Labor
                        <mat-icon class="mibi-stepper-button-icon mibi-stepper-button-icon--trailing" iconPositionEnd>navigate_next</mat-icon>
                    </button>
                </div>
                <button
                    class="mibi-button"
                    mat-stroked-button
                    color="accent"
                    (click)="onSend()"
                >
                    Weiter zum Senden
                </button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
